import { TILE_SIZE } from '@/microfrontends/map/shared/constants/map';

import { POINT_RADIUS } from '../../../services/PinService/impl/constants';
import { fromGlobalPixels } from '../projection';

import { getTilePixelCoords } from './getTilePixelCoords';

type GetExtendedTileBBoxParams = {
  tileNumber: YMaps.TTileNumber;
  zoom: number;
};

export type ExtendedTileBBox = {
  maxX: number;
  maxY: number;
  minX: number;
  minY: number;
};

/**
 * Расширяет область поиска точек внутри тайла, чтобы корректно отрисовать те пины,
 * что попадают на границы тайлов.
 * @todo: посмотреть на реальных данных, нужна ли эта оптимизация
 */
export function getExtendedTileBBox(params: GetExtendedTileBBoxParams): ExtendedTileBBox {
  const { tileNumber, zoom } = params;

  const [tilePixelCoordX, tilePixelCoordY] = getTilePixelCoords(tileNumber);

  const pixelCoordMinX = tilePixelCoordX - POINT_RADIUS;
  const pixelCoordMinY = tilePixelCoordY - POINT_RADIUS;
  const pixelCoordMaxX = tilePixelCoordX + TILE_SIZE + POINT_RADIUS;
  const pixelCoordMaxY = tilePixelCoordY + TILE_SIZE + POINT_RADIUS;

  const [coordMaxX, coordMinY] = fromGlobalPixels([pixelCoordMinX, pixelCoordMinY], zoom);
  const [coordMinX, coordMaxY] = fromGlobalPixels([pixelCoordMaxX, pixelCoordMaxY], zoom);

  return {
    maxX: coordMaxX,
    maxY: coordMaxY,
    minX: coordMinX,
    minY: coordMinY,
  };
}
